/* import __COLOCATED_TEMPLATE__ from './conversation-header-dropdown.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { checkConversationCreationPermission } from 'embercom/lib/permissions/conversation-creation';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import type IntlService from 'embercom/services/intl';
import type PermissionsModal from 'embercom/services/permissions-modal';

interface PermissionsService {
  currentAdminCan(permission: string): boolean;
}

interface Conversation {
  main_participant: { id: string };
  isNotSocial: boolean;
  isGroupConversation: boolean;
}

interface Signature {
  Args: {
    conversation: Conversation;
    downloadTranscript: () => void;
    removeParticipant: () => void;
    isInbox: boolean;
    readOnly: boolean;
  };
  Element: HTMLDivElement;
}

export default class ConversationHeaderDropdown extends Component<Signature> {
  @service declare appService: AppService;
  @service declare router: RouterService;
  @service declare intl: IntlService;
  @service declare permissionsModal: PermissionsModal;
  @service declare permissionsService: PermissionsService;

  get app() {
    return this.appService.app;
  }

  get showAddParticipant() {
    return (
      this.args.isInbox &&
      !this.args.readOnly &&
      this.app?.currentAdminHasInboxAccess &&
      this.args.conversation?.isNotSocial
    );
  }

  get showRemoveParticipant() {
    return (
      this.args.isInbox &&
      !this.args.readOnly &&
      this.args.conversation?.isGroupConversation &&
      this.app?.currentAdminHasInboxAccess
    );
  }

  @action
  startNewConversation(event: MouseEvent) {
    event.preventDefault();

    if (!this.app?.id) {
      return;
    }

    let canProceed = checkConversationCreationPermission({
      appService: this.appService,
      permissionsService: this.permissionsService,
      permissionsModal: this.permissionsModal,
      intl: this.intl,
    });

    if (!canProceed) {
      return;
    }

    this.router.transitionTo('inbox.workspace.inbox.new-conversation', this.app.id, {
      queryParams: {
        overwrite: null,
        recipient: this.args.conversation.main_participant.id,
      },
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox::ConversationHeaderDropdown': typeof ConversationHeaderDropdown;
    'inbox/conversation-header-dropdown': typeof ConversationHeaderDropdown;
  }
}
